module.exports = require("././angular-messages.js");


//////////////////
// WEBPACK FOOTER
// angular-messages (bower component)
// module id = 1080
// module chunks = 1